import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Menu from '../components/Menu';
import Login from '../pages/Login';
import LoginSSO from '../pages/LoginSSO';
import Logout from '../pages/LogoutSSO';
import Devices from '../pages/Devices';
import History from '../pages/History';
import HistoryDetails from '../pages/HistoryDetails';
import Profile from '../pages/Profile';
import Settings from '../pages/Settings';
import Admin from '../pages/Admin';
import Patients from '../pages/Patients';
import PatientDetails from '../pages/PatientDetails';
import DeviceDetails from '../pages/DeviceDetails';
import Register from '../pages/Register';
import ResetPassword from '../pages/ResetPassword';
import Provision from '../pages/Provision';
import AddDevice from '../pages/AddDevice';
import Groups from '../pages/Groups';
import GroupDetails from '../pages/GroupDetails';
import LogoutTimerModal from '../components/LogoutTimerModal';
import 'react-toastify/dist/ReactToastify.css';
import '../components/toast-styles.css';
import { logout, setLastClicked } from '../store/actions/auth';
import { LAST_CLICK_THRESHOLD, COUNTDOWN_TIMER } from '../constants';
import PauseDetails from '../pages/HistoryPauseDetails';
import LowBatteryDetails from '../pages/HistoryLowBatteryDetails';
import NotificationLog from '../pages/NotificationLog';

const AuthorizedRoute = ({ path, component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const authorized = useSelector((state) => state.auth.token);
  const lastClicked = useSelector((state) => state.auth.lastClicked);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    let logoutTimer;
    let modalTimer;
    if (lastClicked) {
      logoutTimer = setTimeout(() => {
        dispatch(logout());
      }, LAST_CLICK_THRESHOLD);
      modalTimer = setTimeout(() => {
        setModalOpen(true);
      }, COUNTDOWN_TIMER);
    }
    return () => {
      clearTimeout(logoutTimer);
      clearTimeout(modalTimer);
    };
  }, [lastClicked]);

  useEffect(() => {
    const subscription = document.addEventListener('click', () => {
      const now = new Date();
      dispatch(setLastClicked(now));
    });
    return () => {
      document.removeEventListener('click', subscription);
    };
  }, []);

  return (
    <Route
      path={path}
      render={() =>
        authorized ? (
          <div>
            <Menu />
            <Component {...rest} />
            <LogoutTimerModal open={modalOpen} setOpen={(val) => setModalOpen(val)} />
          </div>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <AuthorizedRoute exact path="/" component={Patients} />
        <AuthorizedRoute exact path="/history" component={History} />
        <AuthorizedRoute exact path="/history/:id" component={HistoryDetails} />
        <AuthorizedRoute exact path="/history-pauses/:id" component={PauseDetails} />
        <AuthorizedRoute exact path="/history-low-battery/:id" component={LowBatteryDetails} />
        <AuthorizedRoute exact path="/notification-log/:id" component={NotificationLog} />
        <AuthorizedRoute exact path="/monitors" component={Devices} />
        <AuthorizedRoute exact path="/monitors/:id" component={DeviceDetails} />
        <AuthorizedRoute exact path="/add-monitor" component={AddDevice} />
        <AuthorizedRoute exact path="/patients" component={Patients} />
        <AuthorizedRoute exact path="/patients/:id" component={PatientDetails} />
        <AuthorizedRoute exact path="/profile" component={Profile} />
        <AuthorizedRoute exact path="/settings" component={Settings} />
        <AuthorizedRoute exact path="/admin" component={Admin} />
        <AuthorizedRoute exact path="/groups" component={Groups} />
        <AuthorizedRoute exact path="/groups/:id" component={GroupDetails} />
        <AuthorizedRoute exact path="/link" component={Provision} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/reset/:token" component={ResetPassword} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/logout" component={Logout} />
        <Route exact path="/loginsso" component={LoginSSO} />
      </Switch>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
